/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-11-27 09:47:57
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-11-27 19:17:05
 * @FilePath: /work.xhey.top/src/pages/components/PhotoFilter/hooks/useFilterState.ts
 */
import { useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FilterState } from '../types'
import {
  selectUiFilter,
  selectSearchFilter,
  selectDates,
  selectLastPageCond,
  selectIsAscSort,
  setUiFilter,
  setSearchFilter,
  resetFilter as resetFilterAction,
  setLastPageCond,
  setIsAscSort
} from '../../../../slices/photoFilterSlice'
import { getInitialFilter } from '../utils/filterUtils'

/**
 * 筛选状态管理 Hook
 */
export const useFilterState = () => {
  const dispatch = useDispatch()

  const reduxFilter = useSelector(selectUiFilter) || getInitialFilter()
  const reduxQueryFilter = useSelector(selectSearchFilter)
  const reduxDates = useSelector(selectDates)
  const reduxLastPageCond = useSelector(selectLastPageCond)
  const reduxIsAscSort = useSelector(selectIsAscSort)

  const initialFilterRef = useRef<FilterState | null>(null)
  if (!initialFilterRef.current) {
    initialFilterRef.current = reduxFilter
  }

  // 更新UI筛选状态
  const updateFilter = (updates: Partial<FilterState>) => {
    dispatch(setUiFilter(updates))
  }

  // 重置筛选条件
  const resetFilter = () => {
    const initial = initialFilterRef.current || getInitialFilter()
    dispatch(resetFilterAction())
    initialFilterRef.current = initial
  }

  // 设置查询筛选条件
  const updateQueryFilter = (filter: FilterState) => {
    dispatch(setSearchFilter(filter))
  }

  return {
    filter: reduxFilter,
    queryFilter: reduxQueryFilter,
    dates: reduxDates,
    lastPageCond: reduxLastPageCond,
    isAscSort: reduxIsAscSort,
    updateFilter,
    resetFilter,
    updateQueryFilter,
    setLastPageCond: (cond: string) => dispatch(setLastPageCond(cond)),
    setIsAscSort: (isAsc: boolean) => dispatch(setIsAscSort(isAsc))
  }
}
